import { lazy } from 'react';
import pageList from '../../page.config';
// console.log('pages: ------------', pageList);
const pathArr = [
  '/mpweb',
];

// machpro2H5的页面入口文件文件名不使用index,否则调试定位不到原页面文件
export const routerList = pageList.map((item) => {
  const storeIniter: any[] = [];
  const path = `/mpweb/${item.name.replace('c_', '')}`;

  pathArr.push(path);

  return {
    ...item,
    path,
    label: item.title,
    store: item.store,
    storeIniter,
    component: lazy(item.inputImport),
  };
});

export const getPathWithoutQuery = (url) => url?.split?.('?')?.[0];

export const isPathExist = (path) => {
  if (typeof path === 'number') return true;
  // console.log(pathArr, 'pathArr');
  const pathWithoutQuery = getPathWithoutQuery(path);
  // return routerList.some((item) => item.path === pathWithoutQuery);
  return pathArr.includes(pathWithoutQuery);
};

export default [
  ...routerList,
  {
    path: '*',
    label: '首页',
    component: lazy(() => import('@m2h/pages/homepage/home_page_main/main')),
  },
];
